<!-- Pois -->
@for (poi of slideAuthorFacade.currentSelectedImagePois$ | async | sortBy_shared:'asc':'order'; track trackByPoi($index, poi)) {
  <medsurf-design-content-panel [titleText]="poi.name"
    [collapsed]="true"
    [toggleable]="true">
    <div class="flex flex-1 flex-column row-gap-2 p-2 bg-primary-100">
      <span [innerHtml]="poi.note"></span>
      @if (poi.annotationToPointOfInterest.length > 0) {
        <h5 class="m-0">
          {{ 'global.annotations' | translate }}:
        </h5>
        <ul class="flex flex-1 flex-column row-gap-0 m-0">
          @for (annotation of slideAuthorFacade.annotationToPointOfInterests$(poi.annotationToPointOfInterest) | async; track annotation.id) {
            @if (slideAuthorFacade.annotationLabelInfo$(annotation.id, translate) | async; as label) {
              <li>
                {{ label }}
              </li>
            }
          }
        </ul>
      }
    </div>
  </medsurf-design-content-panel>
}
